import { Component, OnInit } from '@angular/core';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { AgendaService } from 'src/app/services/agenda.service';
import { UserConfigService } from 'src/app/services/user-config.service';

@ManageType('AgendaAdminAllDialogComponent')
@Component({
  selector: 'app-agenda-admin-all-dialog',
  templateUrl: './agenda-admin-all-dialog.component.html',
  styleUrls: ['./agenda-admin-all-dialog.component.scss']
})
export class AgendaAdminAllDialogComponent implements OnInit {

  public agendaCategories = [
    {
      name: 'Consultation',
      type: 'consultation'
    },
    {
      name: 'Rendez-vous',
      type: 'appointment'
    }
  ];

  public category = 'consultation';
  public domain;

  constructor(public userConfig: UserConfigService, public agendaSrv: AgendaService) { }

  ngOnInit(): void {
  }

  selectAgenda(event) {
    console.log(event);
    this.agendaSrv.openingHours(event, 2020, 9);
  }
}
